<section class="faq-wrapper section-spacing">
  <div class="faq-header">
    <!-- <p [appGsapSplitTextOnScroll]="0.2" class="section-pill">
      <img loading="lazy" src="/assets/img/icons/faq-icon.svg" width="24" height="24" alt="faq question icon">
      FAQ’s
    </p> -->
    <h2>Frequently Asked Questions</h2>
  </div>

  <div class="faq-list">
    <div *ngFor="let faq of faqs; let i = index" class="faq-item">
      <div
        [appGsapSplitTextOnScroll]="calculateDelay(i)"
        class="quetion-wrapper"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="activeIndex === i"
        (click)="toggleFAQ(i)"
        (keydown.enter)="toggleFAQ(i)"
        (keydown.space)="$event.preventDefault(); toggleFAQ(i)"
      >
        <div class="faq-question" [class.open]="activeIndex === i">
          <p>{{ faq.question }}</p>
        </div>
        <div class="icon-box">
          @if (activeIndex !== i) {
            <span>+</span>
          }

          @if (activeIndex === i) {
            <span>-</span>
          }
        </div>
      </div>

      <div [hidden]="activeIndex !== i" class="faq-answer" [ngClass]="theme">
        <!-- Paragraphs -->
        <ng-container *ngIf="faq.answer.paragraphs?.length">
          <p *ngFor="let para of faq.answer.paragraphs" [innerHTML]="para"></p>
        </ng-container>

        <!-- Unordered List -->
        <ul *ngIf="faq.answer.list?.type === 'ul'">
          <li *ngFor="let item of faq.answer.list?.items">
            {{ item }}
          </li>
        </ul>

        <!-- Ordered List -->
        <ol *ngIf="faq.answer.list?.type === 'ol'">
          <li *ngFor="let item of faq.answer.list?.items">
            {{ item }}
          </li>
        </ol>

        <!-- <svg width="30" height="62" viewBox="0 0 30 62" fill="none">
          <path d="M0.0092392 0H19.0664V21.3442C19.0664 30.3112 19.2259 52.0145 29.4746 61.8805C21.7893 61.8805 3.21403 54.7064 0.0092392 40.3555C-0.0115604 40.3555 0.0092392 0 0.0092392 0Z" fill="#E86939"/>
        </svg> -->
      </div>
    </div>
  </div>
</section>
